import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs";

// Store
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";
import { SportsbookFacade } from "../../../stores/sportsbook/sportsbook.facade";

// Services
import { SportTrackPollingService } from "@sports-services/index";
import { SPORTS_NAVIGATION_SERVICE_ERROR_CODES } from "@sports-services/sports.navigation.service";
import { SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION } from "@sports-services/sports.navigation.service/sports.navigations.constants";
import { SportService } from "@sports-services/sports.service";

@Injectable({ providedIn: "root" })
export class SportsbookSportCountriesEffects {
  // Services
  actions$ = inject(Actions);
  sportService = inject(SportService);

  // Utils
  sportsbookFacade = inject(SportsbookFacade);
  sportTrackPollingService = inject(SportTrackPollingService);

  // SPORTS COUNTRIES PAGE
  fetchSportCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SportsbookActions.fetchSportCountries),
      switchMap((sport: any) => {
        this.sportTrackPollingService.stopAllPollings();
        return this.sportService.getPaisLigaInfo(sport.NodeId).pipe(
          map((data) =>
            SportsbookActions.setSportCountries({
              ...data,
              parentId: sport.NodeId,
            }),
          ),
          catchError((e) => {
            this.sportsbookFacade.setSportsError({
              errorCode: SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR,
              errorDescription: SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION.LOCATION_23,
            });
            return [];
          }),
        );
      }),
    ),
  );
}
